import { ChevronLeft } from '@dreamstack/icons/src/icon-components/ChevronLeft'
import { ChevronRight } from '@dreamstack/icons/src/icon-components/ChevronRight'
import type { KeenSliderInstance } from 'keen-slider'
import type { FunctionComponent, MutableRefObject } from 'react'
import type { KeenSliderOptionTypes } from '../hooks/useResponsiveStackGridOptions'

const chevronClassNames = (
  optionType: KeenSliderOptionTypes,
  disabled?: boolean,
  isLeft?: boolean
) => {
  const classes: string[] = [
    'h-px-32',
    'w-px-32',
    'md:h-px-64',
    'md:w-px-64',
    'cursor-pointer',
  ]
  classes.push(isLeft ? 'left-8' : 'right-8')
  classes.push(disabled ? 'text-accentroGray-100' : 'text-accentroGray-full')

  switch (optionType) {
    case 'PropImageSlider': {
      classes.push(
        disabled ? 'text-accentroWhite-200' : 'text-accentroWhite-full'
      )
      if (isLeft) {
        classes.push(
          'absolute',
          '-left-px-16',
          'md:-left-px-32',
          'top-[calc(50%-32px)]',
          '-translate-x-full'
        )
      } else {
        classes.push(
          'absolute',
          '-right-px-16',
          'md:-right-px-32',
          'top-[calc(50%-32px)]',
          'translate-x-full'
        )
      }
      break
    }
    case 'CurrentPressArticles':
    case 'WorkingForAccentro': {
      classes.push('ml:h-px-80', 'ml:w-px-80')
      break
    }
  }
  return classes.join(' ')
}

export const SliderChevron: FunctionComponent<
  React.PropsWithChildren<{
    slider: MutableRefObject<KeenSliderInstance | null>
    disabled?: boolean
    isLeft?: boolean
    optionType: KeenSliderOptionTypes
  }>
> = ({ slider, disabled, isLeft, optionType }) => {
  return isLeft ? (
    <ChevronLeft
      className={chevronClassNames(optionType, disabled, isLeft)}
      onClick={(e: any) => {
        e.stopPropagation()
        slider.current?.prev()
      }}
    />
  ) : (
    <ChevronRight
      className={chevronClassNames(optionType, disabled, isLeft)}
      onClick={(e: any) => {
        e.stopPropagation()
        slider.current?.next()
      }}
    />
  )
}
